import axios from 'axios'

class PagamentoApiClient {

    async cadastrar(dados) {
        return axios.post('/pagamento/inserir', dados)
    }

    async buscarPorCobrancaId(cobrancaId) {
        return axios.get(`/pagamento/buscarPorCobranca/${cobrancaId}`)
    }

    async editar(dados) {
        return axios.put(`/pagamento/atualizar/${dados.id}`, dados)
    }

    async excluir(id) {
        return axios.delete(`/pagamento/deletar/${id}`)
    }

}

export default new PagamentoApiClient()
